// source: pbtypes/gen/skills/ui_slider.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_ui_slider_style_pb = require('../../../pbtypes/gen/skills/ui_slider_style_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_ui_slider_style_pb);
goog.exportSymbol('proto.skills.UiSlider', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.UiSlider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.UiSlider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.UiSlider.displayName = 'proto.skills.UiSlider';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.UiSlider.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.UiSlider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.UiSlider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiSlider.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
detail: jspb.Message.getFieldWithDefault(msg, 3, ""),
units: jspb.Message.getFieldWithDefault(msg, 4, ""),
style: jspb.Message.getFieldWithDefault(msg, 8, 0),
maxValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
minValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
displayPrecision: jspb.Message.getFieldWithDefault(msg, 9, 0),
stepSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
disabled: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.UiSlider}
 */
proto.skills.UiSlider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.UiSlider;
  return proto.skills.UiSlider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.UiSlider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.UiSlider}
 */
proto.skills.UiSlider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDetail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUnits(value);
      break;
    case 8:
      var value = /** @type {!proto.skills.UiSliderStyle.Enum} */ (reader.readEnum());
      msg.setStyle(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxValue(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinValue(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setValue(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setDisplayPrecision(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStepSize(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.UiSlider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.UiSlider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.UiSlider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiSlider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnits();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getMaxValue();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getMinValue();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getDisplayPrecision();
  if (f !== 0) {
    writer.writeSint32(
      9,
      f
    );
  }
  f = message.getStepSize();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.skills.UiSlider.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.skills.UiSlider.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string detail = 3;
 * @return {string}
 */
proto.skills.UiSlider.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string units = 4;
 * @return {string}
 */
proto.skills.UiSlider.prototype.getUnits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setUnits = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional UiSliderStyle.Enum style = 8;
 * @return {!proto.skills.UiSliderStyle.Enum}
 */
proto.skills.UiSlider.prototype.getStyle = function() {
  return /** @type {!proto.skills.UiSliderStyle.Enum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.skills.UiSliderStyle.Enum} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional float max_value = 5;
 * @return {number}
 */
proto.skills.UiSlider.prototype.getMaxValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setMaxValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float min_value = 6;
 * @return {number}
 */
proto.skills.UiSlider.prototype.getMinValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setMinValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float value = 7;
 * @return {number}
 */
proto.skills.UiSlider.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional sint32 display_precision = 9;
 * @return {number}
 */
proto.skills.UiSlider.prototype.getDisplayPrecision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setDisplayPrecision = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional float step_size = 10;
 * @return {number}
 */
proto.skills.UiSlider.prototype.getStepSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setStepSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional bool disabled = 11;
 * @return {boolean}
 */
proto.skills.UiSlider.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.UiSlider} returns this
 */
proto.skills.UiSlider.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


goog.object.extend(exports, proto.skills);
